export default from './EmailConfirmation';



// WEBPACK FOOTER //
// ./src/components/EmailConfirmation/index.js